import { useRef, useState } from "react";
import HeroSection from "./HeroSection";
import StoreSection from "./StoreSection";
import styled from "styled-components";
import useScrollEnd from "../../../utils/hooks/useScrollEnd";
import Footer from "../Homepage/Footer";

/* #region SCOPED CSS */
const StyledPage = styled.div`
    &.main-retailer-section {
        display: flex;
        width: 100%;
        flex-direction: column;
        height: 100%;
    }
`;
const ScrollableSection = styled.div`
    flex: 1;
    overflow-y: auto;
`;
/* #endregion */

export default function RetailStore() {
    /* #region VARS */
    const [retailBrandData, setRetailBrandData] = useState({});
    const [loading, setLoading] = useState(false);
    const scrollRef = useRef(null);
    const isAtEnd = useScrollEnd(scrollRef, 10);
    /* #endregion */

    /* #region METHODS */
    const handleGetRetailBrandData = brandData => {
        setRetailBrandData(brandData);
    };
    /* #endregion */

    return (
        <StyledPage className="main-retailer-section">
            <ScrollableSection ref={scrollRef}>
                <HeroSection retailBrandData={retailBrandData || ""} loading={loading} />

                <StoreSection
                    handleGetRetailBrandData={handleGetRetailBrandData}
                    setLoading={setLoading}
                    loading={loading}
                    isAtEnd={isAtEnd}
                />

                {!loading && <Footer />}
            </ScrollableSection>
        </StyledPage>
    );
}
